/* bloom-datetime.js — delivery date + window picker.
 *
 * Config arrives from snippets/bloom-pdp-datetime.liquid as a JSON script tag,
 * so this file stays static and browser-cacheable.
 *
 * SLOT RULE: a window is bookable on a given day only if it STARTS at least
 * `buffer` hours from now. Buffer on the start, not the end — an 08:00 order
 * with a 5 h buffer must not be offered 09:00–13:00, only 13:00–18:00.
 */
(function () {
  var root = document.getElementById('bl-dt');
  if (!root || root.dataset.blInit) return;

  var cfgEl = document.querySelector('[data-bl-dt-config]');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  root.dataset.blInit = '1';

  var TZ = 'Europe/Bucharest',
      LOCALE = C.locale,
      CUTOFF = C.cutoff,
      BUFFER = C.buffer,
      MAXDAYS = C.maxDays,
      SLOTS = C.slots || [],
      T = C.t,
      STRIP = 14,
      REQUIRE_EXPLICIT = false;

  var elDays = root.querySelector('[data-bl-days]'),
      elSlots = root.querySelector('[data-bl-slots]'),
      elWrap = root.querySelector('[data-bl-slotwrap]'),
      elOther = root.querySelector('[data-bl-other]'),
      elNative = root.querySelector('[data-bl-native]'),
      elNotice = root.querySelector('[data-bl-notice]'),
      elError = root.querySelector('[data-bl-error]');

  var state = { date: null, slot: null, slotLabel: '' };

  /* ---- Bucharest clock ------------------------------------------------
   * Never the visitor's own clock. A buyer in New York at 08:00 is looking at
   * 15:00 in Bucharest; offering them a 09:00–13:00 window would be offering a
   * slot that ended two hours ago.
   */
  function isoIn(d) {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(d || new Date()); }
    catch (e) { return (d || new Date()).toISOString().slice(0, 10); }
  }
  function hoursNow() {
    try {
      var p = new Intl.DateTimeFormat('en-GB', {
        timeZone: TZ, hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(new Date());
      var h = 0, m = 0;
      p.forEach(function (x) {
        if (x.type === 'hour') h = +x.value;
        if (x.type === 'minute') m = +x.value;
      });
      return h + m / 60;
    } catch (e) {
      var n = new Date();
      return n.getHours() + n.getMinutes() / 60;
    }
  }
  function addDays(iso, n) {
    var d = new Date(iso + 'T12:00:00Z');
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  }
  function toHours(hhmm) {
    var a = String(hhmm).split(':');
    return (+a[0]) + ((+a[1] || 0) / 60);
  }

  var TODAY = isoIn(), NOW = hoursNow();
  var sameDayOpen = NOW < CUTOFF;
  var MIN_DATE = sameDayOpen ? TODAY : addDays(TODAY, 1);
  var MAX_DATE = addDays(TODAY, MAXDAYS);

  function slotsFor(iso) {
    var out = [];
    if (iso === TODAY && !sameDayOpen) return out;
    SLOTS.forEach(function (s) {
      if (iso === TODAY && toHours(s.from) < NOW + BUFFER) return;
      out.push({ id: s.id, label: s.from + '–' + s.to });
    });
    return out;
  }

  if (MIN_DATE === TODAY && slotsFor(TODAY).length === 0) MIN_DATE = addDays(TODAY, 1);

  /* ---- vacation ---------------------------------------------------------
   * C.resume is the first delivery day after a break. While it is still ahead
   * it becomes the earliest bookable date and the strip starts on it, so the
   * buyer is not shown a row of greyed-out days. A past date is ignored.
   */
  var RESUME = /^\d{4}-\d{2}-\d{2}$/.test(C.resume || '') ? C.resume : '';
  var VACATION = !!RESUME && RESUME > MIN_DATE;
  if (VACATION) MIN_DATE = RESUME;
  var STRIP_START = VACATION ? MIN_DATE : TODAY;
  var BASE_NOTICE = VACATION ? T.vacation : (MIN_DATE !== TODAY ? T.closed : '');

  /* ---- labels via Intl: nine locales, no translation table ------------ */
  function fmt(iso, opts) {
    var d = new Date(iso + 'T12:00:00Z');
    try { return new Intl.DateTimeFormat(LOCALE, opts).format(d); }
    catch (e) { return new Intl.DateTimeFormat('en', opts).format(d); }
  }
  function humanDate(iso) {
    return fmt(iso, { weekday: 'long', day: 'numeric', month: 'long' });
  }

  /* ---- render ---------------------------------------------------------- */
  function buildDays() {
    var frag = document.createDocumentFragment(), i, iso, open, b,
        TOMORROW = addDays(TODAY, 1);
    for (i = 0; i < STRIP; i++) {
      iso = addDays(STRIP_START, i);
      open = iso >= MIN_DATE && slotsFor(iso).length > 0;
      b = document.createElement('button');
      b.type = 'button';
      b.className = 'bl-dt__day';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      b.dataset.iso = iso;
      if (!open) b.disabled = true;
      if (iso === TODAY || iso === TOMORROW) {
        b.classList.add('bl-dt__day--wide');
        b.innerHTML = '<span class="bl-dt__dow"></span><span class="bl-dt__num"></span>';
        b.children[0].textContent = iso === TODAY ? T.today : T.tomorrow;
        b.children[1].textContent = fmt(iso, { day: 'numeric', month: 'short' });
      } else {
        b.innerHTML = '<span class="bl-dt__dow"></span><span class="bl-dt__num"></span><span class="bl-dt__mon"></span>';
        b.children[0].textContent = fmt(iso, { weekday: 'short' });
        b.children[1].textContent = fmt(iso, { day: 'numeric' });
        b.children[2].textContent = fmt(iso, { month: 'short' });
      }
      frag.appendChild(b);
    }
    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'bl-dt__day bl-dt__day--wide';
    more.dataset.more = '1';
    more.innerHTML = '<span class="bl-dt__dow"></span><span class="bl-dt__num">…</span>';
    more.children[0].textContent = T.other;
    frag.appendChild(more);

    elDays.appendChild(frag);
    elNative.min = MIN_DATE;
    elNative.max = MAX_DATE;

    if (BASE_NOTICE) {
      elNotice.textContent = BASE_NOTICE;
      elNotice.hidden = false;
    }
  }

  function buildSlots() {
    var list = slotsFor(state.date);
    elSlots.textContent = '';
    if (!list.length) {
      elWrap.hidden = true;
      elNotice.textContent = T.none;
      elNotice.hidden = false;
      state.slot = null;
      sync();
      return;
    }
    if (BASE_NOTICE) elNotice.textContent = BASE_NOTICE;
    else elNotice.hidden = true;
    list.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bl-dt__slot';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      b.dataset.slot = s.id;
      b.dataset.label = s.label;
      var main = document.createElement('span');
      main.textContent = s.label;
      b.appendChild(main);
      elSlots.appendChild(b);
    });
    elWrap.hidden = false;

    var keep = state.slot && elSlots.querySelector('[data-slot="' + state.slot + '"]');
    if (keep) pickSlot(keep);
    else if (!REQUIRE_EXPLICIT) pickSlot(elSlots.firstChild);
    else { state.slot = null; sync(); }
  }

  function pickDate(iso) {
    state.date = iso;
    Array.prototype.forEach.call(elDays.children, function (b) {
      b.setAttribute('aria-checked', b.dataset.iso === iso ? 'true' : 'false');
    });
    if (elNative.value !== iso) elNative.value = iso;
    elError.hidden = true;
    buildSlots();
  }

  function pickSlot(btn) {
    if (!btn) return;
    state.slot = btn.dataset.slot;
    state.slotLabel = btn.dataset.label;
    Array.prototype.forEach.call(elSlots.children, function (b) {
      b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
    });
    elError.hidden = true;
    sync();
  }

  /* ---- the product form ------------------------------------------------ */
  function forms() {
    var scope = document.getElementById('MainContent') || document;
    return scope.querySelectorAll('form[action*="/cart/add"]');
  }

  /* ---- LEGACY SWEEP — delete once the source markup is gone -------------
   * The pre-rewrite delivery modal wrote into a set of hidden inputs with ids
   * hdn-date, hdn-time, hdn-address, hdn-name, hdn-phone, hdn-message,
   * hdn-anon, hdn-opt-call, hdn-opt-door, hdn-opt-photo. Those inputs are
   * still rendered somewhere in product-template-1.liquid, pre-filled with
   * Romanian defaults, and they were reaching checkout: "Ora Livrarii:
   * 13:00-17:00" (a window that no longer exists), plus four rows of "Nu"
   * shown to buyers in every language.
   *
   * This removes them from the form before anything is posted. It is a
   * migration crutch, not architecture — delete this block, and the markup
   * itself, once product-template-1.liquid has been cleaned.
   */
  var LEGACY_NAMES = [
    'Ora Livrării', 'Data Livrării', 'Adresa de Livrare',
    'Nume Destinatar', 'Telefon Destinatar', 'Mesaj Felicitare',
    'Livrare Anonimă', 'Sună Destinatarul', 'Lasă la Ușă',
    'Poză Înainte de Livrare'
  ];
  function drop(node) { if (node && node.parentNode) node.parentNode.removeChild(node); }
  function sweepLegacy() {
    Array.prototype.forEach.call(forms(), function (f) {
      Array.prototype.forEach.call(f.querySelectorAll('[id^="hdn-"]'), drop);
      LEGACY_NAMES.forEach(function (n) {
        Array.prototype.forEach.call(
          f.querySelectorAll('input[name="properties[' + n + ']"]'), drop);
      });
    });
  }

  function setProp(f, name, value) {
    var el = f.querySelector('input[data-bl-prop="' + name + '"]');
    if (!value) { if (el) el.parentNode.removeChild(el); return; }
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      el.setAttribute('data-bl-prop', name);
      f.appendChild(el);
    }
    el.value = value;
  }

  /* Property KEY names come from bloom-details-keys.liquid (one table for
   * every file that writes or reads a line-item property). The config strings
   * are only a fallback for a page where that snippet is absent.
   * _delivery_iso is the single hidden key: sortable and language-free, for
   * Flow, exports and the florist's day sheet. _delivery_slot is gone — the
   * visible window label already says 13:00–18:00 and the cart resolves it. */
  function propNames() {
    var K = window.BloomDetailsKeys && window.BloomDetailsKeys[LOCALE];
    return { date: (K && K.date) || T.propDate, time: (K && K.window) || T.propTime };
  }

  function sync() {
    var ok = !!(state.date && state.slot), N = propNames();
    Array.prototype.forEach.call(forms(), function (f) {
      setProp(f, 'properties[' + N.date + ']', ok ? humanDate(state.date) : '');
      setProp(f, 'properties[' + N.time + ']', ok ? state.slotLabel : '');
      setProp(f, 'properties[_delivery_iso]', ok ? state.date : '');
      setProp(f, 'properties[_delivery_slot]', '');
    });
    document.dispatchEvent(new CustomEvent('bloom:delivery-change', { detail: publicState() }));
  }

  function publicState() {
    return {
      date: state.date,
      slot: state.slot,
      slotLabel: state.slotLabel,
      dateLabel: state.date ? humanDate(state.date) : ''
    };
  }

  /* ---- events ---------------------------------------------------------- */
  elDays.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('button') : null;
    if (!b || b.disabled) return;
    if (b.dataset.more) {
      elOther.hidden = false;
      elNative.focus();
      if (elNative.showPicker) { try { elNative.showPicker(); } catch (err) {} }
      return;
    }
    pickDate(b.dataset.iso);
  });

  elSlots.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('button') : null;
    if (!b || b.disabled) return;
    pickSlot(b);
  });

  elNative.addEventListener('change', function () {
    var v = elNative.value;
    if (!v || v < MIN_DATE || v > MAX_DATE) return;
    if (!slotsFor(v).length) {
      elNotice.textContent = T.none;
      elNotice.hidden = false;
      return;
    }
    pickDate(v);
  });

  /* Capture phase, so this runs before any theme AJAX handler swallows submit.
   * The sweep repeats here in case the theme re-renders the form after load. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    sweepLegacy();
    if (state.date && state.slot) return;
    e.preventDefault();
    e.stopPropagation();
    elError.textContent = T.pick;
    elError.hidden = false;
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  sweepLegacy();
  buildDays();
  if (!REQUIRE_EXPLICIT) pickDate(MIN_DATE);

  window.BloomDelivery = {
    get: publicState,
    setDate: function (iso) { if (iso >= MIN_DATE && iso <= MAX_DATE && slotsFor(iso).length) pickDate(iso); },
    setProp: function (name, value) {
      Array.prototype.forEach.call(forms(), function (f) { setProp(f, name, value); });
    },
    minDate: MIN_DATE,
    maxDate: MAX_DATE,
    slotsFor: slotsFor
  };
})();
